/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/button-has-type */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable react/jsx-no-useless-fragment */
import Icon, {
  ArrowRightOutlined,
  CaretDownOutlined,
  FrownTwoTone,
  MailOutlined,
  MessageOutlined,
  SmileFilled,
  SmileOutlined,
  SmileTwoTone,
} from "@ant-design/icons";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { Avatar, Button, Divider, Drawer, Form, Popover, Table, Tooltip, Typography } from "antd";
import { capitalize, isEmpty, sortBy } from "lodash";
import React, { Fragment, useContext, useMemo, useState } from "react";
import ReactMarkdown from "react-markdown";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { EAI_LOGO_GRAPHIC_ONLY } from "../../../config";
// eslint-disable-next-line import/no-extraneous-dependencies
import EngagedAI from "../../../../static/EngagedAi_trans_bg.svg";
import DealerraterIcon from "../../../../static/icons/DealerraterIcon.svg";
import FacebooksIcon from "../../../../static/icons/FacebooksIcon.svg";
import GoogleIcon from "../../../../static/icons/GoogleIcon.svg";
import TranslateIcon from "../../../../static/icons/TranslateIcon.svg";
import YelpIcon from "../../../../static/icons/YelpIcon.svg";
import { UserContext } from "../../../amplify/authenticator-provider";
import { CREATE_EMAIL, TRANSLATE_MESSAGE } from "../../../graphql/mutation";
import { GET_DETECTED_LANGUAGE, GET_SUPPORTED_LANGUAGES } from "../../../graphql/query";
import useCrmIntegration from "../../../hooks/useCrmIntegration";
import useLang from "../../../hooks/useLang";
import { ReplyIcon } from "../../../icons/js/EmailIcons";
import PencilIcon from "../../../icons/js/PencilIcon";
import { ReminderIcon16 } from "../../../icons/js/RemainderIcon";
import { SVGIcon } from "../../../library/basicComponents";
import { AccessPermissionAction, MESSAGE_CONTENT_TYPES } from "../../../library/constants";
import { checkAccessPermission } from "../../../library/helpers";
import { convertUtcToLocal, formatBytes } from "../../../library/utils";
import { getMobileView } from "../../../redux/slices/isMobile";
import { setTranlatedContent } from "../../../redux/slices/leadSlice";
import AntdIconV4 from "../../../utils/antdIcon";
import { convertToInitials } from "../../layoutComponent/layoutHelpers";
import { ReplyEmail } from "./Emails";
import { isTypeOfCampaignEmail, parseEmailReply, renderLinks } from "./engagementHelpers";
import BellIcon from "./icons/BellIcon";
import Calendar12Icon from "./icons/calendar";
import CampaignEmailIcon from "./icons/CampaignEmailIcon";
import CampaignMessageIcon from "./icons/CampaignMessageIcon";
import EmailIcon from "./icons/EmailIcon";
import EnvalopeIcon from "./icons/EnvalopeIcon";
import GreenEnvalopeIcon from "./icons/greenEnvalope";
import HandShake from "./icons/handShake";
import SadIcon from "./icons/SadIcon";
import MediaSharing from "./mediaSharing/mediaSharing";
import MultipleMediaView from "./mediaSharing/multipleMediaView";
import "./messages.css";
import { renderEmailStatus } from "../../../constant/EmailConstant";

export const AppointmentBox = styled.div`
  text-align: center;
  margin: 2rem auto;
  width: 75%;
  @media (max-width: 488px) {
    width: 80%;
  }
  & .ant-alert-info,
  .ant-alert-success {
    border: 0;
  }
  & .anticon-calendar,
  .anticon-android {
    font-size: 20px;
    color: #007dae;
  }
  background: red;
`;
export const LineDiv = styled.div`
  &::before {
    background: ${props => props.colorprop} !important;
  }
`;
function parsePhone(selectedLead, crmIntegration, user, c) {
  const toPhoneNumber =
    (c?.messageLog && c?.messageLog.length > 0 && c?.messageLog[0].toPhone) || "";
  return toPhoneNumber;
}

const Messages = props => {
  const {
    SetContentBy,
    c: message,
    userIdMap,
    selectedLead,
    handleRetry,
    messageIndex,
    canViewTranslation,
    isIncludeOriginalMessage,
  } = props;
  const crmIntegration = useCrmIntegration();
  const dispatch = useDispatch();
  const { user } = useContext(UserContext);
  const [isOpenOttoMessage, setisOpenOttoMessage] = useState(false);
  const toPhone = parsePhone(selectedLead, crmIntegration, user, message);
  const msgType = (message?.messageType || "").toLowerCase();
  const msgContentType = (message?.contentType || "").toLowerCase();
  const [showMore, setShowMore] = useState(false);
  const [showMoreForReview, setShowMoreForReview] = useState(false);
  const [showMoreForCustomeAlert, setShowMoreForCustomeAlert] = useState(false);
  const [lang] = useLang();
  const isMobileView = useSelector(state => getMobileView(state));
  const { translatedContent } = useSelector(state => state.lead);
  const [translateMessage, { loading: translateMessageLoader }] = useMutation(TRANSLATE_MESSAGE);
  const [detectedLanguage, setDetectedLanguage] = useState(null);
  const [languages, setLanguages] = useState([]);
  const [visible, setVisible] = useState(false);
  const [showTranslatedText, setShowTranslatedText] = useState(true);
  const [visibleTranslateIcon, setVisibleTranslateIcon] = useState(false);

  const canEmailView = checkAccessPermission(AccessPermissionAction.EMAIL_MANAGEMENT_VIEW);

  const { refetch: refetchSupportedLanguages } = useQuery(GET_SUPPORTED_LANGUAGES, {
    onCompleted: res => {
      setLanguages(res?.getSupportedLanguages);
    },
  });

  const [getDetectedLanguage, { loading: getDetectedLanguageLoader }] = useLazyQuery(
    GET_DETECTED_LANGUAGE,
    {
      variables: {
        content: message?.translatedContent || message?.content,
      },
      onCompleted: res => {
        const possibleDetectedLanguage = languages?.find(item =>
          item?.languageCode.includes(res?.getLanguageCode?.code)
        );
        setDetectedLanguage(possibleDetectedLanguage?.languageCode);
      },
    }
  );

  function getTranslatedTextById() {
    const foundObj = translatedContent.find(obj => obj.id === message?.id);
    return foundObj ? foundObj.translatedContent : null;
  }

  const returnTranslatedContent = () => {
    if (getTranslatedTextById()) {
      return (
        <>
          {(isIncludeOriginalMessage || getTranslatedTextById()) && (
            <Divider style={{ margin: "16px 0", background: "#94A3B8" }} />
          )}
          Translated Text:
          <br />
          {renderLinks(getTranslatedTextById(), "black")}
        </>
      );
    }
  };

  const returnTranslatedContentGlobally = content => {
    if (content) {
      return (
        <>
          {isIncludeOriginalMessage && (
            <Divider style={{ margin: "16px 0", background: "#94A3B8" }} />
          )}
          Translated Text:
          <br />
          {renderLinks(content, "black")}
        </>
      );
    }
  };

  const doTranslation = () => {
    translateMessage({
      variables: {
        content: message?.content,
        messageId: message?.id,
      },
      onCompleted: res => {
        if (res?.translateMessage?.statusCode === 200) {
          const temp = {
            id: message?.id,
            translatedContent: res?.translateMessage?.translatedContent,
          };
          !translatedContent.some(obj => +obj.id === +temp.id) &&
            dispatch(setTranlatedContent(temp));
          // message.info(res?.translateMessage?.message);
        } else {
          message.info(res?.translateMessage?.message);
        }
      },
    });
  };

  const RenderTranslation = () => {
    return (
      msgType !== "mms" && (
        <Tooltip title="Translate message">
          <span className="items-center" style={{ zIndex: 999 }}>
            <SVGIcon component={TranslateIcon} alt="Translate" onClick={() => doTranslation()} />
          </span>
        </Tooltip>
      )
    );
  };

  const RenderPhone = props => {
    const { direction, messagephone } = props;
    return (
      <div className={`${direction === "FROM_LEAD" ? "text-left" : "text-right"} clear-both`}>
        <span className="text-xs font-[400] text-white">
          {`Message ${direction === "FROM_LEAD" ? "received from" : "sent to"}: ${messagephone}`}
        </span>
      </div>
    );
  };

  const RenderRetry = ({ allowRetry = true, className }) => {
    const errorMessage = `${message.errorCode || ""} ${message.errorMessage || ""}`;
    return (
      <Typography
        className={`!flex !items-center !justify-end !gap-2 !mr-8 ${className}`}
        variant="small"
        weight="medium"
      >
        <Tooltip placement="top" title={isEmpty(errorMessage.trim()) ? null : errorMessage}>
          <span>
            <AntdIconV4 type="ExclamationCircleFilled" className="text-red-500 text-xs" />
          </span>
        </Tooltip>
        <span className="text-[#FF4D4F] font-normal text-xs">{lang.msgFailedSend}. </span>
        {allowRetry && (
          <div
            className="text-[#1783FF] text-xs font-semibold cursor-pointer"
            onClick={e => handleRetry(e, message)}
          >
            {lang.retry}
          </div>
        )}
        {/* <p className="text-[11px] mb-[2px] text-right mr-[15px]">
      {userIdMap
        ? c?.systemUserId
          ? userIdMap && userIdMap[c?.systemUserId]
          : userIdMap && userIdMap[c?.userId]
        : c.user.fullName}{" "}
      {lang.postedAt}{" "}
      {convertUtcToLocal(c?.dateSent, "ddd, MMM Do YYYY, h:mm A")}
      <br />
      {c?.errorMessage}
    </p> */}
      </Typography>
    );
  };
  let index = 0;
  const components = {
    img: ({ src, alt }) => (
      <a
        href={document.getElementById(`cardetail-${index}`)?.getAttribute("href")}
        target="_blank"
        rel="noreferrer"
        id=""
      >
        <img width={133} height={103} src={src} alt={alt} style={{ borderRadius: "5px" }} />
      </a>
    ),
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    a: ({ href, children }) => {
      index += 1;
      return (
        <a href={href} target="_blank" rel="noreferrer" id={`cardetail-${index}`}>
          {children}
        </a>
      );
    },
    ul: ({ children }) => (
      <ul
        style={{
          listStyle: "none",
          padding: "0px",
          margin: "0px",
        }}
      >
        {children}
      </ul>
    ),
  };

  const getMessageCategory = () => {
    // use icons from the JSX elements created from figma icons
    let msgCat = {
      title: "Notification",
      // icon: <BellIcon color="#A855F7" />,
      backgroundColor: "#DBEAFE",
    };
    if (msgType === "email") {
      // welcome Message
      msgCat = {
        title: `${message?.campaign?.name || "Campaign Email"}`,
        icon: <EmailIcon />,
        backgroundColor: "#F3E8FF",
      };
    } else if (msgContentType === MESSAGE_CONTENT_TYPES.WELCOME_MESSAGE.toLowerCase()) {
      // welcome Message
      msgCat = {
        title: "Welcome Message",
        icon: <HandShake />,
        backgroundColor: "#F3E8FF",
      };
    } else if (msgContentType === MESSAGE_CONTENT_TYPES.NEW_MESSAGE_RECEIVED.toLowerCase()) {
      msgCat = {
        title: "New Message Received",
        icon: <EnvalopeIcon />,
        backgroundColor: "#F3E8FF",
      };
    }
    // New Message reminder
    else if (msgContentType === MESSAGE_CONTENT_TYPES.NEW_MESSAGE_REMINDER.toLowerCase()) {
      msgCat = {
        title: "New Message Reminder",
        icon: <EnvalopeIcon />,
        backgroundColor: "#F3E8FF",
      };
    } else if (
      [
        MESSAGE_CONTENT_TYPES.APPOINTMENT_RESCHEDULE_TO_USER.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_SCHEDULED_TO_USER.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_CANCELLED_TO_USER.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_CONFIRMED_NOTIFICATION_TO_USER.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_STATUS_UPDATE_BY_OTTO.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_RESCHEDULED_ALERT_TO_USER.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_SCHEDULED_NOTIFICATION_TO_USER.toLowerCase(),
      ].includes(msgContentType) &&
      msgType.toLowerCase() === "otto"
    ) {
      msgCat = {
        title: "Appointment Nudge",
        icon: <Calendar12Icon />,
        backgroundColor: "#DBEAFE",
        className: "normal-otto",
      };
    } else if (
      [
        MESSAGE_CONTENT_TYPES.APPOINTMENT_RESCHEDULED_ALERT_TO_USER.toLowerCase(),
        MESSAGE_CONTENT_TYPES.REQUEST_TO_RESCHEDULE_APPOINTMENT.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_RESCHEDULE_TO_LEAD.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_RESCHEDULE_TO_USER.toLowerCase(),
        MESSAGE_CONTENT_TYPES.SENT_APPOINTMENT_RESCHEDULE_LINK_TO_LEAD.toLowerCase(),
      ].includes(msgContentType)
    ) {
      msgCat = {
        title: "Appointment Rescheduled",
        icon: <Calendar12Icon />,
        backgroundColor: "#DBEAFE",
        className: "normal-otto",
      };
    } else if (
      [
        MESSAGE_CONTENT_TYPES.NEW_APPOINTMENT_CREATED.toLowerCase(),
        MESSAGE_CONTENT_TYPES.NEW_APPOINTMENT_CREATED_TO_LEAD.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_SCHEDULED.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_SCHEDULED_TO_LEAD.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_SCHEDULED_NOTIFICATION_TO_USER.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_SCHEDULED_TO_USER.toLowerCase(),
      ].includes(msgContentType)
    ) {
      msgCat = {
        title: "Appointment Booked",
        icon: <Calendar12Icon />,
        backgroundColor: "#DBEAFE",
        className: "normal-otto",
      };
    } else if (
      [
        MESSAGE_CONTENT_TYPES.APPOINTMENT_REMINDER_MESSAGE_TO_LEAD.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_PAST_REMINDER.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_PAST_REMINDER_TO_LEAD.toLowerCase(),
        MESSAGE_CONTENT_TYPES.NOT_ACTIVE_APPOINTMENT_TO_LEAD.toLowerCase(),
      ].includes(msgContentType)
    ) {
      msgCat = {
        title: "Appointment Reminder",
        icon: (
          <div className="flex flex-row items-center gap-1">
            <BellIcon />
            <Calendar12Icon />
          </div>
        ),
        backgroundColor: "#DBEAFE",
        className: "normal-otto",
      };
    } else if (
      [
        MESSAGE_CONTENT_TYPES.APPOINTMENT_CANCELLED.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_CANCELLED_TO_LEAD.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_CANCELLED_TO_USER.toLowerCase(),
      ].includes(msgContentType)
    ) {
      // Appointment Cancelled
      msgCat = {
        title: "Appointment Cancelled",
        backgroundColor: "#DBEAFE",
        className: "cancel-otto",
        icon: (
          <div className="flex flex-row items-center gap-1">
            {/* <CancelledIcon /> */}
            <Calendar12Icon />
          </div>
        ),
      };
    } else if (
      [
        MESSAGE_CONTENT_TYPES.APPOINTMENT_CONFIRMED.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_CONFIRMED_TO_LEAD.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_CONFIRMED_NOTIFICATION_TO_USER.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_CONFIRMED_NOTIFICATION_TO_LEAD.toLowerCase(),
      ].includes(msgContentType)
    ) {
      msgCat = {
        title: "Appointment Confirmed",
        backgroundColor: "#DBEAFE",
        className: "normal-otto",
        icon: (
          <div className="flex flex-row items-center gap-1">
            {/* <CheckBoxIcon /> */}
            <Calendar12Icon />
          </div>
        ),
      };
    } else if (
      [
        MESSAGE_CONTENT_TYPES.APPOINTMENT_NO_SHOWED_STATUS_TO_LEAD.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_SHOWED_STATUS_TO_LEAD.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_STATUS_UPDATE_BY_OTTO.toLowerCase(),
        MESSAGE_CONTENT_TYPES.APPOINTMENT_STATUS_UPDATE.toLowerCase(),
      ].includes(msgContentType)
    ) {
      msgCat = {
        title: "Appointment Status Update",
        backgroundColor: "#DBEAFE",
        className: "normal-otto",
        icon: (
          <div className="flex flex-row items-center gap-1">
            {/* <CheckBoxIcon /> */}
            <Calendar12Icon />
          </div>
        ),
      };
    } else if ([MESSAGE_CONTENT_TYPES.REVIEW_REQUEST_SENT.toLowerCase()].includes(msgContentType)) {
      msgCat = {
        title: <span className="text-nowrap">Review Request Sent</span>,
        icon: <SmileOutlined />,
        backgroundColor: "#FEF3C7",
        className: "normal-otto",
      };
    } else if (
      [
        MESSAGE_CONTENT_TYPES.CAMPAIGN.toLowerCase(),
        MESSAGE_CONTENT_TYPES.CAMPAIGN_MESSAGE_TO_LEAD.toLowerCase(),
        MESSAGE_CONTENT_TYPES.CAMPAIGN_REVIEW_REQUEST_SENT_TO_LEAD.toLowerCase(),
      ].includes(msgContentType)
    ) {
      msgCat = {
        title: message?.campaign?.name || "Campaign",
        icon:
          message?.campaign?.method === "Email" ? <CampaignEmailIcon /> : <CampaignMessageIcon />,
        backgroundColor: "#DBEAFE",
        className: "normal-otto",
      };
    } else if (
      [
        MESSAGE_CONTENT_TYPES.REVIEW_BAD_FROM_LEAD.toLowerCase(),
        MESSAGE_CONTENT_TYPES.CUSTOMER_COPIED_REVIEW_SUGGESTION.toLowerCase(),
        MESSAGE_CONTENT_TYPES.CUSTOMER_GENERATED_REVIEW_SUGGESTION.toLowerCase(),
        MESSAGE_CONTENT_TYPES.FACEBOOK_REVIEW_LINK_CLICKED.toLowerCase(),
        MESSAGE_CONTENT_TYPES.GOOD_REVIEW_FROM_LEAD.toLowerCase(),
        MESSAGE_CONTENT_TYPES.GOOGLE_REVIEW_LINK_CLICKED.toLowerCase(),
        MESSAGE_CONTENT_TYPES.BAD_REVIEW_FROM_LEAD.toLowerCase(),
        MESSAGE_CONTENT_TYPES.GOOD_REVIEW_GIVEN_FROM_LEAD.toLowerCase(),
        MESSAGE_CONTENT_TYPES.YELP_REVIEW_LINK_CLICKED.toLowerCase(),
      ].includes(msgContentType)
    ) {
      msgCat = {
        title: <span className="text-nowrap">Review</span>,
        icon: <SmileOutlined />,
        backgroundColor: "#FEF3C7",
        className: "normal-otto",
      };
    } else if (
      [MESSAGE_CONTENT_TYPES.NEW_MESSAGE_MERGED_LEAD.toLowerCase()].includes(msgContentType)
    ) {
      msgCat = {
        title: "Merged Records",
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} fill="none">
            <path
              fill="#22C55E"
              d="M15.37 6.627a7.5 7.5 0 1 0-8.743 8.743 7.5 7.5 0 1 0 8.743-8.743ZM2 7.999a6 6 0 0 1 11.812-1.5 7.507 7.507 0 0 0-7.308 7.312 6.01 6.01 0 0 1-4.505-5.813Zm12 12a6.01 6.01 0 0 1-5.813-4.5 7.508 7.508 0 0 0 7.313-7.313 6 6 0 0 1-1.5 11.813Z"
            />
          </svg>
        ),
        backgroundColor: "#DCFCE7",
      };
    } else if (
      [MESSAGE_CONTENT_TYPES.NEW_OPPORTUNITY_MESSAGE_MERGED_LEAD.toLowerCase()].includes(
        msgContentType
      )
    ) {
      msgCat = {
        title: "Opportunity Merged",
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width={22} height={22} fill="none">
            <path
              fill="#22C55E"
              d="M15.37 6.627a7.5 7.5 0 1 0-8.743 8.743 7.5 7.5 0 1 0 8.743-8.743ZM2 7.999a6 6 0 0 1 11.812-1.5 7.507 7.507 0 0 0-7.308 7.312 6.01 6.01 0 0 1-4.505-5.813Zm12 12a6.01 6.01 0 0 1-5.813-4.5 7.508 7.508 0 0 0 7.313-7.313 6 6 0 0 1-1.5 11.813Z"
            />
          </svg>
        ),
        // backgroundColor: "#DCFCE7",
      };
    } else if (
      [
        MESSAGE_CONTENT_TYPES.NUDGE_NEW_LEAD_MESSAGE.toLowerCase(),
        MESSAGE_CONTENT_TYPES.NUDGE_RECEIVED_BY_SMAI_OTTO_FROM_USER.toLowerCase(),
      ].includes(msgContentType)
    ) {
      msgCat = {
        title: "Nudge",
        icon: <BellIcon />,
        backgroundColor: "#DBEAFE",
        className: "normal-otto",
      };
    } else if ([MESSAGE_CONTENT_TYPES.AI_RESPONSE_TO_LEAD.toLowerCase()].includes(msgContentType)) {
      msgCat = {
        title: "Otto Message",
        icon: <BellIcon />,
        backgroundColor: "#DBEAFE",
        className: "normal-otto",
      };
    } else if (
      [MESSAGE_CONTENT_TYPES.SCHEDULED_MESSAGE_SENT.toLowerCase()].includes(msgContentType)
    ) {
      msgCat = {
        title: "Scheduled Message Sent",
        backgroundColor: "#CCFBF1",
        icon: <ReminderIcon16 />,
        className: "normal-otto",
      };
    } else if (
      [
        MESSAGE_CONTENT_TYPES.SCHEDULED_MESSAGE.toLowerCase(),
        MESSAGE_CONTENT_TYPES.SCHEDULED_MESSAGE_TO_LEAD.toLowerCase(),
      ].includes(msgContentType)
    ) {
      msgCat = {
        title: "Scheduled Message",
        backgroundColor: "#CCFBF1",
        icon: <ReminderIcon16 />,
        className: "normal-otto",
      };
    } else if (
      [MESSAGE_CONTENT_TYPES.SCHEDULED_MESSAGE_CANCELLED.toLowerCase()].includes(msgContentType)
    ) {
      msgCat = {
        title: "Scheduled Message Cancelled",
        backgroundColor: "#fbcccc",
        icon: <ReminderIcon16 />,
        className: "cancel-otto",
      };
    } else {
      msgCat = {
        title: "Notification",
        icon: <BellIcon />,
        backgroundColor: "#DBEAFE",
        className: "normal-otto",
      };
    }
    return msgCat;
  };

  const messageCategory = useMemo(getMessageCategory, [msgContentType, msgType, message?.campaign]);

  // Expand campaign message by default
  useMemo(() => {
    if (messageCategory && messageCategory.title === "Campaign") {
      setisOpenOttoMessage(true);
    }
  }, [messageCategory]);

  const userName = useMemo(() => {
    if (!isEmpty(userIdMap)) {
      const uName =
        message?.contentType === "AI Response To Lead"
          ? lang.autoResponderUserName
          : message?.systemUserId && message?.systemUserId != null
          ? userIdMap[+message?.systemUserId]
          : userIdMap[+message?.userId];
      return uName || message?.user?.fullName || user?.fullName;
    }
    return message?.user?.fullName || user?.fullName;
  }, [message, user, userIdMap]);

  const isCampaignEmailMessage =
    msgType === "email" &&
    message?.campaign &&
    msgContentType === MESSAGE_CONTENT_TYPES.CAMPAIGN_MESSAGE_TO_LEAD.toLowerCase();

  return isEmpty(message) ? null : msgType !== "mms" ? (
    <div
      id={`msg-${messageIndex}`}
      className=""
      // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
      onMouseOver={() => setVisibleTranslateIcon(true)}
      onMouseLeave={() => {
        setVisibleTranslateIcon(false);
        setVisible(false);
      }}
    >
      <Fragment key={message?.id}>
        {["appointment", "otto", "review", "merge_lead", "merge_opportunity"].includes(msgType) ||
        isCampaignEmailMessage ? (
          <OttoMessage
            user={user}
            showMoreForCustomeAlert={showMoreForCustomeAlert}
            SetContentBy={SetContentBy}
            c={message}
            userIdMap={userIdMap}
            setShowMoreForCustomeAlert={setShowMoreForCustomeAlert}
            lang={lang}
            selectedLead={selectedLead}
            toPhone={toPhone}
            RenderRetry={RenderRetry}
            msgContentType={msgContentType}
            messageCategory={messageCategory}
            isOpenOttoMessage={isOpenOttoMessage}
            setisOpenOttoMessage={setisOpenOttoMessage}
            isReview={msgType === "review"}
            isLeadMerged={msgType === "merge_lead"}
            isOpportunityMerged={msgType === "merge_opportunity"}
            msgType={msgType}
            canEmailView={canEmailView}
          />
        ) : msgType !== "call" ? (
          <div>
            {message?.direction === "FROM_LEAD" ||
            message?.direction === "TO_USER" ||
            (message?.direction === "FROM_OTTO" && msgType === "review") ? (
              <div className="flex justify-start" key={message?.id}>
                {msgType.toLowerCase() === "email" ? (
                  <>
                    {canEmailView ? (
                      <EmailJSX
                        message={message}
                        isMobileView={isMobileView}
                        selectedLead={selectedLead}
                        canViewTranslation={canViewTranslation}
                        visibleTranslateIcon={visibleTranslateIcon}
                        RenderTranslation={RenderTranslation}
                        msgType={msgType}
                        msgContentType={msgContentType}
                        RenderPhone={RenderPhone}
                        lang={lang}
                        showMoreForReview={showMoreForReview}
                        isIncludeOriginalMessage={isIncludeOriginalMessage}
                        user={user}
                        getTranslatedTextById={getTranslatedTextById}
                        returnTranslatedContentGlobally={returnTranslatedContentGlobally}
                        returnTranslatedContent={returnTranslatedContent}
                        isOttoEmail={false}
                      />
                    ) : null}
                  </>
                ) : (
                  <FromLeadSMS
                    isMobileView={isMobileView}
                    selectedLead={selectedLead}
                    canViewTranslation={canViewTranslation}
                    visibleTranslateIcon={visibleTranslateIcon}
                    RenderTranslation={RenderTranslation}
                    msgType={msgType}
                    msgContentType={msgContentType}
                    message={message}
                    RenderPhone={RenderPhone}
                    lang={lang}
                    showMoreForReview={showMoreForReview}
                    isIncludeOriginalMessage={isIncludeOriginalMessage}
                    user={user}
                    getTranslatedTextById={getTranslatedTextById}
                    returnTranslatedContentGlobally={returnTranslatedContentGlobally}
                    returnTranslatedContent={returnTranslatedContent}
                  />
                )}
              </div>
            ) : (
              <div className="flex justify-end" key={message?.id}>
                {msgType === "email" ? (
                  <>
                    {canEmailView ? (
                      <EmailJSX
                        message={message}
                        isMobileView={isMobileView}
                        selectedLead={selectedLead}
                        canViewTranslation={canViewTranslation}
                        visibleTranslateIcon={visibleTranslateIcon}
                        RenderTranslation={RenderTranslation}
                        msgType={msgType}
                        msgContentType={msgContentType}
                        RenderPhone={RenderPhone}
                        lang={lang}
                        showMoreForReview={showMoreForReview}
                        isIncludeOriginalMessage={isIncludeOriginalMessage}
                        user={user}
                        getTranslatedTextById={getTranslatedTextById}
                        returnTranslatedContentGlobally={returnTranslatedContentGlobally}
                        returnTranslatedContent={returnTranslatedContent}
                        userName={userName}
                      />
                    ) : null}
                  </>
                ) : (
                  <ToLeadSMS
                    isMobileView={isMobileView}
                    message={message}
                    user={user}
                    canViewTranslation={canViewTranslation}
                    visibleTranslateIcon={visibleTranslateIcon}
                    RenderTranslation={RenderTranslation}
                    RenderPhone={RenderPhone}
                    lang={lang}
                    userName={userName}
                    components={components}
                    isIncludeOriginalMessage={isIncludeOriginalMessage}
                    getTranslatedTextById={getTranslatedTextById}
                    returnTranslatedContentGlobally={returnTranslatedContentGlobally}
                    returnTranslatedContent={returnTranslatedContent}
                    RenderRetry={RenderRetry}
                  />
                )}
              </div>
            )}
          </div>
        ) : (
          <div className="flex justify-center">
            <div className="bg-[#52c41ade] rounded-[15px] p-[10px] text-white flex flex-col text-center">
              <AntdIconV4 type="PhoneOutlined" className="mb-[1em]" />
              {selectedLead?.fullName || ""} {lang.called} {message?.user?.firstName || ""}
              {message?.user?.lastName || ""} <br /> {lang.at.toLowerCase()}
              {convertUtcToLocal(message.dateSent, "ddd, MMM Do YYYY, h:mm A")}
            </div>
          </div>
        )}
      </Fragment>
    </div>
  ) : message.direction === "TO_LEAD" ? (
    <div className="flex justify-end w-full" key={message?.id} id={`msg-${messageIndex}`}>
      <ToLeadMessage
        isMobileView={isMobileView}
        c={message}
        user={user}
        canViewTranslation={canViewTranslation}
        visibleTranslateIcon={visibleTranslateIcon}
        RenderTranslation={RenderTranslation}
        RenderPhone={RenderPhone}
        userName={userName}
        isIncludeOriginalMessage={isIncludeOriginalMessage}
        getTranslatedTextById={getTranslatedTextById}
        returnTranslatedContentGlobally={returnTranslatedContentGlobally}
        returnTranslatedContent={returnTranslatedContent}
        RenderRetry={RenderRetry}
      />
    </div>
  ) : (
    <div className="flex justify-start" key={message?.id} id={`msg-${messageIndex}`}>
      <FromLeadMessage
        isMobileView={isMobileView}
        selectedLead={selectedLead}
        canViewTranslation={canViewTranslation}
        visibleTranslateIcon={visibleTranslateIcon}
        RenderTranslation={RenderTranslation}
        RenderPhone={RenderPhone}
        c={message}
        isIncludeOriginalMessage={isIncludeOriginalMessage}
        user={user}
        getTranslatedTextById={getTranslatedTextById}
        returnTranslatedContentGlobally={returnTranslatedContentGlobally}
        returnTranslatedContent={returnTranslatedContent}
      />
    </div>
  );
};

export default Messages;

function ToLeadSMS({
  isMobileView,
  message,
  user,
  canViewTranslation,
  visibleTranslateIcon,
  RenderTranslation,
  RenderPhone,
  userName,
  components,
  isIncludeOriginalMessage,
  getTranslatedTextById,
  returnTranslatedContentGlobally,
  returnTranslatedContent,
  RenderRetry,
}) {
  return (
    <div
      className={
        !isMobileView ? "max-w-[80%] md:max-w-[65%] break-words" : "break-words w-[80%] max-w-full "
      }
    >
      {message?.messageType === "WIDGET_CHAT" && (
        <div className="text-right">
          <AntdIconV4 type="MobileFilled" className="w-full text-center text-[#007dae]" />
        </div>
      )}
      {/* <div className="flex items-center">
          <Avatar
            src={message?.user?.profilePic || ""}
            className={`absolute right-0 mx-1 ${
              message?.user?.profilePimessage?.length > 0 ? "" : "bg-[#f6df9c]"
            }`}
          >
            <span className="text-[#64748B]">
              {" "}
              {convertToInitials(
                !isEmpty(userIdMap)
                  ? message?.systemUserId
                    ? userIdMap && userIdMap[message?.systemUserId]
                    : userIdMap && userIdMap[message?.userId]
                  : user.fullName
              )}
            </span>
          </Avatar>
          <span
            style={{
              position: "absolute",
              right: "0%",
            }}
          >
            {canViewTranslation && visibleTranslateIcon && <RenderTranslation />}
          </span>
        </div> */}
      <div className="absolute right-0 mx-1 flex flex-col mt-[5px]">
        <Avatar
          src={
            message?.contentType === "AI Response To Lead"
              ? EAI_LOGO_GRAPHIC_ONLY
              : message?.user?.profilePic || ""
          }
          className={`${
            message?.contentType === "AI Response To Lead" || message?.user?.profilePic?.length > 0
              ? ""
              : "bg-[#f6df9c]"
          } h-6 w-6 flex-row-centered items-center justify-center`}
          style={{
            marginLeft: "auto",
          }}
        >
          <span className="text-[#64748B]">
            {convertToInitials(message?.user?.fullName || user?.fullName)}
          </span>
        </Avatar>
        {canViewTranslation && visibleTranslateIcon && <RenderTranslation />}
      </div>
      <div className="text-[14px] md:float-none float-right items-end flex flex-col  relative break-words ml-[4px] mr-[30px]">
        <div className="flex justify-end items-center">
          <div className="flex-row-centered items-center gap-1">
            <MessageOutlined className="text-grey-500" />
            <Tooltip title={convertUtcToLocal(message?.dateSent, "ddd, MMM Do YYYY, h:mm A")}>
              <span className="text-xs font-[400] text-grey-500">
                {convertUtcToLocal(message?.dateSent, "h:mm A")}
              </span>
            </Tooltip>
            <Tooltip
              title={
                <RenderPhone
                  direction="TO_LEAD"
                  messagephone={
                    (message?.messageLog &&
                      message?.messageLog.length > 0 &&
                      message?.messageLog[0]?.toPhone) ||
                    ""
                  }
                />
              }
            >
              <span className="text-grey-700 line-clamp-1 text-xs font-[600]">{userName}</span>
            </Tooltip>
          </div>
        </div>
        {message?.campaign && message?.campaign?.name !== "Default" && (
          <span className="absolute top-[-12px] left-[15px] py-[2px] px-[10px] bg-orange-500 rounded-[6px] text-[12px]">
            {message?.campaign?.name || ""}
          </span>
        )}
        <div className="smaiChatSent">
          {message?.contentType === "AI Response To Lead" ? (
            <ReactMarkdown components={components}>{message?.content}</ReactMarkdown>
          ) : (
            renderLinks(
              isIncludeOriginalMessage || user?.isTranslationEnabled
                ? message?.content
                : message?.translatedContent || message?.content,
              "black"
            )
          )}

          {(isIncludeOriginalMessage || getTranslatedTextById()) && <br />}
          {isIncludeOriginalMessage &&
            !getTranslatedTextById() &&
            message?.content !== message?.translatedContent &&
            returnTranslatedContentGlobally(message?.translatedContent)}
          {returnTranslatedContent()}
        </div>
        {/* <AntdIconV4
          type={
            c?.type === "new"
              ? "LoadingOutlined"
              : c?.type === "error" || c?.messageStatus === "FAILED"
              ? ""
              : "CheckOutlined"
          }
          className={`text-[14px] ml-[10px] ${
            c?.type === "error" ? "text-red-500" : "text-white"
          }`}
        /> */}
      </div>
      {message?.type === "error" ||
      message?.messageStatus === "FAILED" ||
      message?.messageStatus === "UNDELIVERED" ? (
        <span className="text-[11px] mb-[2px] text-right mr-[15px]">
          <RenderRetry />
        </span>
      ) : message?.type === "new" ? null : (
        <>
          {/* <p className="text-[11px] mb-[2px] text-right mr-[15px]">{userSentMessage}</p>
                {c?.leadOpportunity?.id && (
                  <p className="text-[11px] text-right mt-[1px] mb-[3px] mr-[15px]">
                    {isMobileView ? (showMoreMessageInfo ? opportunity : "") : opportunity}
                  </p>
                )}
                {isMobileView && showMoreToggleRight} */}
        </>
      )}
    </div>
  );
}

function FromLeadSMS({
  isMobileView,
  selectedLead,
  canViewTranslation,
  visibleTranslateIcon,
  RenderTranslation,
  msgType,
  msgContentType,
  message,
  RenderPhone,
  lang,
  showMoreForReview,
  isIncludeOriginalMessage,
  user,
  getTranslatedTextById,
  returnTranslatedContentGlobally,
  returnTranslatedContent,
}) {
  return (
    <div
      className={
        !isMobileView
          ? "w-[70%] lg:w-[60%] max-w-[80%] break-words"
          : "break-words w-full max-w-full"
      }
    >
      <div className="absolute left-0 mx-1 flex flex-col mt-[5px]">
        <Avatar className="bg-error-400 flex-row-centered text-grey-200 text-[9.6px] font-[600] items-center justify-center h-6 w-6">
          {convertToInitials(selectedLead?.fullName)}
        </Avatar>

        {canViewTranslation && visibleTranslateIcon && <RenderTranslation />}
      </div>
      <div>
        {msgType === "review" &&
          (msgContentType?.includes("good") || msgContentType?.includes("bad")) && (
            <div className="flex items-center justify-end">
              {message?.contentType?.includes("Good") ? (
                <SmileTwoTone twoToneColor="#52c41a" className="text-[20px]" />
              ) : (
                <FrownTwoTone twoToneColor="red" className="text-[20px]" />
              )}
            </div>
          )}
        <div className="text-[14px] flex-col-centered px-[1em] mx-[4px] ml-[20px] relative md:float-none float-left">
          <div className="flex justify-between items-center">
            <div className="flex-row-centered items-center gap-1">
              <Tooltip
                title={
                  <RenderPhone
                    direction="FROM_LEAD"
                    messagephone={
                      (message?.messageLog &&
                        message?.messageLog.length > 0 &&
                        message?.messageLog[0]?.fromPhone) ||
                      ""
                    }
                  />
                }
              >
                <span
                  title={selectedLead?.fullName}
                  className="text-brand-500 text-xs line-clamp-1 font-[600] "
                >
                  {selectedLead?.fullName}
                </span>
              </Tooltip>
              <Tooltip title={convertUtcToLocal(message?.dateReceived, "ddd, MMM Do YYYY, h:mm A")}>
                <span className="text-xs font-[400] text-grey-500">
                  {convertUtcToLocal(message?.dateReceived, "h:mm A")}
                </span>
              </Tooltip>
              <MessageOutlined className="text-grey-500" />
            </div>
          </div>
          {msgType === "review" && (
            <span className="absolute top-[-12px] left-[15px] py-[2px] px-[10px] bg-yellow-200 text-amber-700 rounded-[6px] text-[12px]">
              {lang.review}
            </span>
          )}
          <div className="smaiChatRecieve">
            {isMobileView
              ? showMoreForReview
                ? renderLinks(
                    isIncludeOriginalMessage || user?.isTranslationEnabled
                      ? message?.content
                      : message?.translatedContent || message?.content,
                    "black"
                  ) || ""
                : `${renderLinks(
                    isIncludeOriginalMessage || user?.isTranslationEnabled
                      ? message?.content
                      : message?.translatedContent || message?.content,
                    "black"
                  )}`
              : renderLinks(
                  isIncludeOriginalMessage || user?.isTranslationEnabled
                    ? message?.content
                    : message?.translatedContent || message?.content,
                  "black"
                )}
            {/* {isMobileView && c?.content?.length > 60 ? (
          showMoreForReview ? (
            <span
              className="showMoreButtonForRecievedMessage"
              onClick={() => setShowMoreForReview(false)}
            >
              {lang.showLess}
            </span>
          ) : (
            <span
              className="showMoreButtonForRecievedMessage"
              onClick={() => setShowMoreForReview(true)}
            >
              {lang.showMore}
            </span>
          )
        ) : (
          ""
        )} */}
            {(isIncludeOriginalMessage || getTranslatedTextById()) && <br />}
            {isIncludeOriginalMessage &&
              message?.translatedContent &&
              !getTranslatedTextById() &&
              message?.content !== message?.translatedContent &&
              returnTranslatedContentGlobally(message?.translatedContent)}
            {returnTranslatedContent()}
          </div>
        </div>
      </div>
      {/* <p className="text-left ml-[4px] mb-[4px] text-[11px]">
          {recievedMessageInfo} <br />
          {isMobileView ? (showMoreMessageInfo ? opportunity : "") : opportunity}
          {isMobileView && showMoreToggle}
        </p> */}

      {/* {c?.leadOpportunity?.id && (
        <p className="text-[11px] text-left mt-[1px] mb-[3px] ml-[4px]">
          {lang.opportunity}: {c?.leadOpportunity?.name} ({handleOpportunityId(c)})
        </p>
      )} */}
    </div>
  );
}

function FromLeadMessage({
  isMobileView,
  selectedLead,
  canViewTranslation,
  visibleTranslateIcon,
  RenderTranslation,
  RenderPhone,
  c,
  isIncludeOriginalMessage,
  user,
  getTranslatedTextById,
  returnTranslatedContentGlobally,
  returnTranslatedContent,
}) {
  return (
    <div
      className={
        !isMobileView ? "max-w-[80%] md:max-w-[65%] break-words" : "break-words w-full max-w-full"
      }
    >
      <div className="absolute left-0 mx-1 flex flex-col mt-[5px]">
        <Avatar className="bg-[#abc5de] items-center justify-center flex-row-centered h-6 w-6">
          {convertToInitials(selectedLead?.fullName)}
        </Avatar>
        {canViewTranslation && visibleTranslateIcon && <RenderTranslation />}
      </div>
      <div className="text-[14px] flex-col-centered px-[1em] mx-[4px] ml-[20px] relative md:float-none float-left">
        <div className="flex justify-between items-center">
          <div className="flex-row-centered items-center gap-1">
            <Tooltip
              title={
                <RenderPhone
                  direction="FROM_LEAD"
                  messagephone={
                    (c?.messageLog && c?.messageLog.length > 0 && c?.messageLog[0]?.fromPhone) || ""
                  }
                />
              }
            >
              <span className="text-brand-500 text-xs font-[600] line-clamp-1">
                {selectedLead?.fullName}
              </span>
            </Tooltip>
            <Tooltip title={convertUtcToLocal(c?.dateReceived, "ddd, MMM Do YYYY, h:mm A")}>
              <span className="text-xs font-[400] text-grey-500">
                {convertUtcToLocal(c?.dateReceived, "h:mm A")}
              </span>
            </Tooltip>
            <MessageOutlined className="text-grey-500" />
          </div>
        </div>
        <div className="smaiChatRecieve">
          <div className="flex justify-center">
            {c?.mmsObjects?.length <= 1 ? (
              <MediaSharing
                alt="msgText"
                direction={c.direction}
                selectedMedia={{
                  mediaUrl: c?.mmsObjects[0]?.mediaUrl,
                  mediaType: c?.mmsObjects[0]?.mediaType,
                  size: c?.mmsObjects[0]?.size,
                  thumbnailUrl: c?.mmsObjects[0]?.thumbnail,
                }}
                width="250px"
                height="230px"
              />
            ) : (
              <MultipleMediaView
                messageDetails={c}
                media={c.mmsObjects}
                selectedMedia={c.mmsObjects && c.mmsObjects[0]}
                alt="msgText"
                direction={c.direction}
                width="250px"
                height="230px"
              />
            )}
          </div>
          {c.content && (
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
                padding: "10px 0 0 0",
              }}
            >
              <span>
                {renderLinks(
                  isIncludeOriginalMessage || user?.isTranslationEnabled
                    ? c?.content
                    : c?.translatedContent || c?.content,
                  "black"
                ) || ""}
              </span>
              {(isIncludeOriginalMessage || getTranslatedTextById()) && <br />}
              {isIncludeOriginalMessage &&
                c?.translatedContent &&
                !getTranslatedTextById() &&
                c?.content !== c?.translatedContent &&
                returnTranslatedContentGlobally(c?.translatedContent)}
              {returnTranslatedContent()}
            </div>
          )}
        </div>
      </div>
      {/* <p className="text-left ml-[4px] mb-[4px] text-[11px]">
          {recievedMessageInfo} <br />
          {isMobileView ? (showMoreMessageInfo ? opportunity : "") : opportunity}
          {isMobileView && showMoreToggle}
        </p> */}
    </div>
  );
}

function ToLeadMessage({
  isMobileView,
  c,
  user,
  canViewTranslation,
  visibleTranslateIcon,
  RenderTranslation,
  RenderPhone,
  userName,
  isIncludeOriginalMessage,
  getTranslatedTextById,
  returnTranslatedContentGlobally,
  returnTranslatedContent,
  RenderRetry,
}) {
  return (
    <div
      className={
        !isMobileView
          ? "max-w-[80%] md:max-w-[65%] break-words "
          : "break-words  w-full max-w-full "
      }
    >
      <div className="absolute right-0 mx-1 flex flex-col mt-[5px]">
        <Avatar
          src={
            c?.contentType === "AI Response To Lead"
              ? EAI_LOGO_GRAPHIC_ONLY
              : c?.user?.profilePic || ""
          }
          className={`${
            c?.contentType === "AI Response To Lead" || c?.user?.profilePic?.length > 0
              ? ""
              : "bg-[#f6df9c]"
          } flex-row-centered items-center justify-center h-6 w-6`}
        >
          <span className="text-[#64748B]">
            {" "}
            {convertToInitials(c?.user?.fullName || user?.fullName)}
          </span>
        </Avatar>

        {canViewTranslation && visibleTranslateIcon && <RenderTranslation />}
      </div>
      <div className="text-[14px] flex flex-col  relative break-words mr-[30px] ml-[4px] float-right md:float-none">
        <div className="flex justify-end items-center">
          <div className="flex-row-centered items-center gap-1">
            <MessageOutlined className="text-grey-500" />
            <Tooltip title={convertUtcToLocal(c?.dateSent, "ddd, MMM Do YYYY, h:mm A")}>
              <span className="text-xs font-[400] text-grey-500">
                {convertUtcToLocal(c?.dateSent, "h:mm A")}
              </span>
            </Tooltip>
            <Tooltip
              title={
                <RenderPhone
                  direction="TO_LEAD"
                  messagephone={
                    (c?.messageLog && c?.messageLog.length > 0 && c?.messageLog[0]?.toPhone) || ""
                  }
                />
              }
            >
              <span className="text-grey-700 line-clamp-1 text-xs font-[600]">{userName}</span>
            </Tooltip>
          </div>
        </div>
        <div className="smaiChatSent">
          <div className="flex justify-center">
            {c?.mmsObjects?.length <= 1 ? (
              <MediaSharing
                alt="msgText"
                direction={c.direction}
                selectedMedia={{
                  mediaUrl: c?.mmsObjects[0]?.mediaUrl,
                  mediaType: c?.mmsObjects[0]?.mediaType,
                  size: c?.mmsObjects[0]?.size,
                  thumbnailUrl: c?.mmsObjects[0]?.thumbnail,
                }}
                width="250px"
                height="230px"
              />
            ) : (
              <MultipleMediaView
                messageDetails={c}
                media={c.mmsObjects}
                alt="msgText"
                direction={c.direction}
                width="250px"
                height="230px"
              />
            )}
          </div>
          {c.content && (
            <>
              {c?.campaign && c?.campaign?.name !== "Default" && (
                <span>{c?.campaign?.name || ""}</span>
              )}
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                  padding: "10px 0 0 0",
                }}
              >
                <span className="break-all">
                  {renderLinks(
                    isIncludeOriginalMessage || user?.isTranslationEnabled
                      ? c?.content || c?.translatedContent
                      : c?.translatedContent || c?.content,
                    "black"
                  ) || ""}
                </span>
                {(isIncludeOriginalMessage || getTranslatedTextById()) && <br />}
                {isIncludeOriginalMessage &&
                  c?.content !== c?.translatedContent &&
                  !getTranslatedTextById() &&
                  returnTranslatedContentGlobally(c?.translatedContent)}
                {returnTranslatedContent()}
                {/* <AntdIconV4
                type={
                  c?.type === "new"
                    ? "loading"
                    : c?.type === "error" || c?.messageStatus === "FAILED"
                    ? ""
                    : "check"
                }
                style={{
                  fontSize: "14px",
                  marginLeft: 10,
                  color: `${c?.type === "error" ? "red" : "white"}`,
                }}
              /> */}
              </div>
            </>
          )}
        </div>
      </div>
      {(c?.type === "error" ||
        c?.messageStatus === "FAILED" ||
        c?.messageStatus === "UNDELIVERED") && (
        <p className="text-[11px] mb-[2px] text-right mr-[15px]">
          <RenderRetry />
        </p>
      )}
    </div>
  );
}
const EmailJSX = ({
  message,
  user,
  isMobileView,
  selectedLead,
  userName,
  isOttoEmail = false,
  // canViewTranslation,
  // visibleTranslateIcon,
  // RenderTranslation,
}) => {
  // const dispatch = useDispatch();
  const { direction, email } = message;
  const [emailForm] = Form.useForm();
  const [isExpanded, setIsExpanded] = useState(false);
  const [isShowMore, setIsShowMore] = useState(false);
  const [replyEmail, setreplyEmail] = useState({
    visible: false,
    leadId: selectedLead?.id,
    leadOpportunityId: message?.leadOpportunity?.id,
    email: "",
    id: "",
    showSubject: false,
    mode: "Reply",
    emailData: null,
  });
  // Function to parse the content
  /**
   *
   * @param {string} htmlBody
   * @returns
   */

  const {
    newMessage: initialContent,
    originalMessage: expandedContent,
    isReply,
  } = parseEmailReply(message?.content || "");

  const canSendEmail = checkAccessPermission(AccessPermissionAction.EMAIL_MANAGEMENT_SEND);

  const EmailDetails = () => {
    const emailDetailClassName = `flex flex-row items-start my-1`;
    const labelClassName = "text-xs font-normal text-[#64748B] w-12 text-right mr-2";
    const valueClassName = "text-xs font-normal text-[#334155] break-words";

    return (
      <div className={`flex flex-col w-full ${isOttoEmail ? "bg-grey-100 rounded-lg p-2" : ""}`}>
        <div className={emailDetailClassName}>
          <span className={labelClassName}>From:</span>
          <span className={valueClassName}>
            {["FROM_LEAD", "TO_USER"].includes(direction) ? selectedLead?.fullName : ""}{" "}
            {["FROM_LEAD", "TO_USER"].includes(direction) && selectedLead?.fullName ? <br /> : ""}
            {["FROM_LEAD", "TO_USER"].includes(direction)
              ? `<${email?.from_ || ""}>`
              : `${email?.from_ || ""}`}
          </span>
        </div>
        <div className={emailDetailClassName}>
          <span className={labelClassName}>To:</span>
          <span className={valueClassName}>
            {direction === "TO_LEAD" ? selectedLead?.fullName : ""}
            {direction === "TO_LEAD" && selectedLead?.fullName && <br />}
            {`${email?.to || ""}`}
          </span>
        </div>
        <div className={emailDetailClassName}>
          <span className={labelClassName}>Date:</span>
          <span className={valueClassName}>
            {convertUtcToLocal(
              message.dateSent || message.dateReceived,
              "ddd, DD MMM YYYY hh:mm A"
            )}
          </span>
        </div>
        <div className={emailDetailClassName}>
          <span className={labelClassName}>Subject:</span>
          <span className={valueClassName}>{email?.subject || ""}</span>
        </div>
      </div>
    );
  };

  const handleReplyEmail = () => {
    setreplyEmail({
      ...replyEmail,
      visible: true,
      leadId: selectedLead?.id,
      leadOpportunityId: message?.leadOpportunity?.id,
      showSubject: true,
      mode: "Reply",
      id: email?.id,
      email: message?.direction === "TO_LEAD" ? email.to : email.from_,
      emailData: {
        ...email,
        bodyHtml: message.content,
      },
    });
    // dispatch(setTextMode("Email"));
  };

  const handleForwardEmail = () => {
    setreplyEmail({
      ...replyEmail,
      visible: true,
      leadId: selectedLead?.id,
      leadOpportunityId: message?.leadOpportunity?.id,
      showSubject: true,
      mode: "Forward",
      email: "",
      emailData: {
        ...email,
        bodyHtml: message.content,
      },
    });
    // dispatch(setTextMode("Email"));
  };

  const [createEmail, { loading: emailLoader }] = useMutation(CREATE_EMAIL);

  return (
    <div
      className={`${
        direction === "TO_LEAD"
          ? "flex-row-centered justify-end"
          : "flex-row-centered justify-start"
      } items-start gap-1 mx-1 ${
        !isMobileView && !isOttoEmail ? "max-w-[80%] md:max-w-[64.5%]" : "max-w-full"
      } ${!isOttoEmail ? "w-webkit-fill" : "w-full"} `}
    >
      {["FROM_LEAD", "TO_USER"].includes(direction) && !isOttoEmail && (
        <div>
          <Avatar className="bg-error-400 flex-row-centered text-grey-200 text-[9.6px] font-[600] items-center justify-center h-6 w-6">
            {convertToInitials(selectedLead?.fullName)}
          </Avatar>
        </div>
      )}

      <div className={isOttoEmail ? "flex-col-centered w-full" : "w-[inherit] flex-col-centered"}>
        {isOttoEmail ? (
          <EmailDetails isOttoEmail={isOttoEmail} />
        ) : (
          <div
            className={`${
              direction === "TO_LEAD"
                ? "flex-row-centered justify-end"
                : "flex-row-centered justify-start"
            }`}
          >
            {direction === "TO_LEAD" ? (
              <div className="flex-row-centered gap-1 items-center mb-1">
                {renderEmailStatus(message?.email?.status)}
                <Popover trigger={["click"]} content={<EmailDetails isOttoEmail={isOttoEmail} />}>
                  <MailOutlined className="text-grey-500" />
                </Popover>
                <Tooltip title={convertUtcToLocal(message.dateSent, "ddd, MMM Do YYYY, h:mm A")}>
                  <span className="xs-400 text-grey-500">
                    {convertUtcToLocal(message.dateSent, "hh:mm A")}
                  </span>
                </Tooltip>
                <Tooltip title={userName}>
                  <span className="text-grey-700 line-clamp-1 text-xs font-[600]">{userName}</span>
                </Tooltip>
              </div>
            ) : (
              <div className="flex-row-centered gap-1 pb-1 items-center">
                <span className="xs-600 line-clamp-1 text-brand-500">
                  {message?.selectedLead?.fullName || selectedLead?.fullName || ""}
                </span>
                <Tooltip
                  title={convertUtcToLocal(message.dateReceived, "ddd, MMM Do YYYY, h:mm A")}
                >
                  <span className="xs-400 text-grey-500">
                    {convertUtcToLocal(message.dateReceived, "hh:mm A")}
                  </span>
                </Tooltip>
                <Popover trigger={["click"]} content={<EmailDetails />}>
                  <MailOutlined className="text-grey-500 ml-1" />
                </Popover>
                {renderEmailStatus(message?.email?.status)}
              </div>
            )}
          </div>
        )}

        <div
          className={`${
            direction === "TO_LEAD" ? "smaiChatSent ml-auto w-full" : "smaiChatRecieve"
          }  bg-white`}
        >
          {!isTypeOfCampaignEmail(message?.contentType) && (
            <div className="flex-row-centered items-center justify-between">
              <span className="text-md font-[500] text-grey-600 py-3 border-0 border-b border-solid border-grey-200 w-full">
                Subject: {message?.email?.subject || "No Subject"}
              </span>
            </div>
          )}

          <div>
            {isShowMore ? (
              <>
                <div
                  dangerouslySetInnerHTML={{
                    __html: initialContent.replace(/^\n+/, "").replace(/\n/g, "<br />"),
                  }}
                />
                <span
                  className="toggle-reply cursor-pointer font-semibold text-blue-500"
                  onClick={() => setIsShowMore(false)}
                >
                  See less
                </span>
              </>
            ) : (
              <>
                <div
                  dangerouslySetInnerHTML={{
                    __html: initialContent
                      ?.slice(0, 300)
                      ?.replace(/^\n+/, "")
                      ?.replace(/\n/g, "<br />"),
                  }}
                />
                {initialContent?.length > 300 && (
                  <span
                    className="toggle-reply cursor-pointer font-semibold text-blue-500"
                    onClick={() => setIsShowMore(true)}
                  >
                    See more
                  </span>
                )}
              </>
            )}
          </div>
          {/* <div dangerouslySetInnerHTML={{ __html: initialContent }} /> */}
          {isReply && (
            <div className="reply-section">
              <span
                className="toggle-reply text-[2rem] leading-[0] text-[#64748B] cursor-pointer"
                onClick={() => setIsExpanded(!isExpanded)}
              >
                {isExpanded ? "..." : "..."}
              </span>

              {isExpanded && (
                <blockquote
                  className="border-0 border-l border-solid border-[#ccc] text-[#666] pl-2"
                  dangerouslySetInnerHTML={{ __html: expandedContent }}
                />
              )}
            </div>
          )}
          {(message?.mmsObjects || []).length > 0 &&
            (message?.mmsObjects || []).map((item, index) => (
              <div
                key={index}
                className="rounded border border-solid flex-row-centered max-w-max gap-1 px-3 py-2 border-grey-200 bg-grey-50"
              >
                <span
                  className="sm-400 text-brand-500 cursor-pointer"
                  onClick={() => window.open(item.mediaUrl)}
                >
                  {item?.mediaUrl?.split("/")?.pop()}
                </span>
                <span className="sm-400 text-grey-500">({formatBytes(item.size)})</span>
              </div>
            ))}
          <div className="flex-row-centered items-center justify-between">
            {["FROM_LEAD", "TO_USER", "TO_LEAD"].includes(message?.direction) && canSendEmail && (
              <div className="flex gap-2 items-center">
                <Tooltip title="Reply">
                  <Button
                    type="default"
                    icon={<ReplyIcon />}
                    onClick={() => handleReplyEmail()}
                    className="flex items-center mt-2 text-xs text-grey-700 bg-white border border-grey-300 hover:bg-grey-50"
                  >
                    Reply
                  </Button>
                </Tooltip>
                <Tooltip title="Reply">
                  <Button
                    type="default"
                    icon={<ReplyIcon className="rotate-180 scale-y-[-1]" />}
                    onClick={() => handleForwardEmail()}
                    className="flex items-center mt-2 text-xs text-grey-700 bg-white border border-grey-300 hover:bg-grey-50"
                  >
                    Forward
                  </Button>
                </Tooltip>
              </div>
            )}
          </div>
        </div>
      </div>
      {message.direction === "TO_LEAD" && !isOttoEmail && (
        <div>
          <Avatar
            src={
              direction === "TO_LEAD"
                ? message?.contentType === "AI Response To Lead"
                  ? EAI_LOGO_GRAPHIC_ONLY
                  : message?.user?.profilePic || ""
                : null
            }
            className={`${
              message?.contentType === "AI Response To Lead" ||
              message?.user?.profilePic?.length > 0
                ? ""
                : "bg-[#f6df9c]"
            } h-6 w-6 flex-row-centered items-center justify-center`}
            style={{
              marginLeft: "auto",
            }}
          >
            <span className="text-[#64748B]">
              {convertToInitials(
                direction === "TO_LEAD"
                  ? message?.user?.fullName || user?.fullName
                  : message.selectedLead.fullName
              )}
            </span>
          </Avatar>
        </div>
      )}

      {replyEmail.visible && (
        <Drawer
          open={replyEmail.visible}
          // @ts-ignore
          onClose={() => setreplyEmail({ visible: false, email: "", mode: "Reply" })}
          width={window.innerWidth <= 1024 ? "80%" : "40%"}
          destroyOnClose
          title={
            replyEmail?.mode === "Forward"
              ? "Forward Email"
              : `Reply to ${
                  direction === "TO_LEAD"
                    ? replyEmail?.email
                    : replyEmail?.emailData?.from_ || replyEmail?.email || ""
                }`
          }
          footer={
            <div className="flex-row-centered w-full items-center">
              <div className="flex-row-centered gap-1">
                <Button loading={emailLoader} onClick={() => emailForm.submit()} type="primary">
                  Send
                </Button>
                <Button onClick={() => setreplyEmail({ visible: false, email: "" })}>Cancel</Button>
              </div>
            </div>
          }
        >
          <ReplyEmail
            key={message.id}
            // @ts-ignore
            showReply={replyEmail}
            // @ts-ignore
            setshowReply={setreplyEmail}
            selectedLead={selectedLead}
            emailForm={emailForm}
            createEmail={createEmail}
            selectedEmail={email}
            refetchEmails={() => {}}
            refetchEmailListFn={() => {}}
            textMode={"Email"}
          />
        </Drawer>
      )}
    </div>
  );
};

function ReviewUI({ c }) {
  // const reviewStages = ["Invite Opened", "Good Experience", "Review Posted", "Review Message"];
  const sortedtracking = sortBy(c?.trackingDetails, "id");
  const invited = sortedtracking.find(item => item.action);
  const opened = sortedtracking.find(
    item =>
      item?.actionType?.toLowerCase() === "view" && item?.actionValue?.toLowerCase() === "start"
  );
  const clickGood = sortedtracking.find(
    item =>
      item?.actionType?.toLowerCase() === "click" && item?.actionValue?.toLowerCase() === "good"
  );
  const clickBad = sortedtracking.find(
    item =>
      item?.actionType?.toLowerCase() === "click" && item?.actionValue?.toLowerCase() === "bad"
  );
  const ottoUsed = sortedtracking.find(
    item =>
      item?.actionType?.toLowerCase() === "click" &&
      item?.actionValue?.toLowerCase() === "suggest_message_gen"
  );
  const clickPlatform = sortedtracking.find(
    item =>
      item?.actionType?.toLowerCase() === "click" &&
      (item?.actionValue?.toLowerCase() === "google" ||
        item?.actionValue?.toLowerCase() === "facebook" ||
        item?.actionValue?.toLowerCase() === "yelp" ||
        item?.actionValue?.toLowerCase() === "dealer_rater")
  );
  const TrackingContainer = ({ children, tooltip = null }) => (
    <Tooltip trigger="hover" title={tooltip}>
      <span className="flex flex-row gap-1 items-center text-xs font-bold text-grey-700">
        {children}
      </span>
    </Tooltip>
  );
  return (
    <div className="w-[95%] h-full flex flex-col justify-center items-center mx-auto">
      {/* Review Stage UI */}
      <div className="flex flex-row flex-wrap w-full items-center justify-center gap-3 mb-2">
        {!isEmpty(opened) && (
          <TrackingContainer tooltip="Lead opened the invite">
            Invite Opened
            <GreenEnvalopeIcon />
          </TrackingContainer>
        )}
        {!isEmpty(clickGood) && (
          <>
            <ArrowRightOutlined />
            <TrackingContainer tooltip="Lead indicated that they had a satisfactory experience.">
              Good Experience
              <SmileFilled className="text-brand-500" />
            </TrackingContainer>
          </>
        )}
        {!isEmpty(clickBad) && (
          <>
            <ArrowRightOutlined />
            <TrackingContainer tooltip="Lead indicated that they had an unsatisfactory experience.">
              Bad Experience
              <SadIcon />
            </TrackingContainer>
          </>
        )}
        {!isEmpty(ottoUsed) && (
          <>
            <ArrowRightOutlined />
            <TrackingContainer tooltip="Review is written using OTTO and copied">
              Otto Written
              <Icon className="text-xs" component={EngagedAI} alt="SocialMiningAi" />
            </TrackingContainer>
          </>
        )}
        {!isEmpty(clickPlatform) && isEmpty(ottoUsed) && (
          <>
            <ArrowRightOutlined />
            <TrackingContainer tooltip="Review is self written by customer.">
              Self Written
              <PencilIcon color="#F59E0B" />
            </TrackingContainer>
          </>
        )}
        {!isEmpty(clickPlatform) && (
          <>
            <ArrowRightOutlined />
            <TrackingContainer
              tooltip={`Customer opened ${capitalize(clickPlatform?.actionValue)} review site.`}
            >
              Customer opened
              <SVGIcon
                component={
                  clickPlatform?.actionValue === "GOOGLE"
                    ? GoogleIcon
                    : clickPlatform?.actionValue === "FACEBOOK"
                    ? FacebooksIcon
                    : clickPlatform?.actionValue === "YELP"
                    ? YelpIcon
                    : DealerraterIcon
                }
                className="h-[12px] w-[12px]"
                alt="Rating"
              />
            </TrackingContainer>
          </>
        )}
      </div>
    </div>
  );
}

function MergedLeadUI({ c }) {
  const dataSource = JSON.parse(c?.content)?.map((item, index) => ({
    key: `${index + 1}`,
    name: item.fullname,
    email: item.merge_history.email[0]?.email || "N/A",
    phone: item.merge_history.phone[0]?.phone || "N/A",
    leadSource: item.lead_source || "N/A",
    status: item?.status || "N/A",
    voi: `${item?.merge_history?.vehicle_of_interest[0]?.make || ""} ${
      item?.merge_history?.vehicle_of_interest[0]?.year || ""
    } ${item?.merge_history?.vehicle_of_interest[0]?.model || ""}`,
  }));

  const columns = [
    {
      dataIndex: "name",
      key: "name",
      onCell: () => ({
        style: {
          color: "#3B82F6",
          backgroundColor: "#DCFCE7",
        },
      }),
    },
    {
      dataIndex: "leadSource",
      key: "leadSource",
      onCell: () => ({
        style: { backgroundColor: "#DCFCE7" },
      }),
    },
    {
      dataIndex: "phone",
      key: "phone",
      onCell: () => ({
        style: { backgroundColor: "#DCFCE7" },
      }),
    },
    {
      dataIndex: "voi",
      key: "voi",
      render: value => <span>{value?.trim() || "No vehicle"}</span>,
      onCell: () => ({
        style: { backgroundColor: "#DCFCE7" },
      }),
    },
    {
      dataIndex: "status",
      key: "status",
      onCell: () => ({
        style: { backgroundColor: "#DCFCE7" },
      }),
    },
  ];

  return (
    <Table
      dataSource={dataSource}
      columns={columns}
      pagination={false}
      className="hide-header divider-table"
    />
  );
}

function MergedOpportunityUI({ c }) {
  const dataSource = JSON.parse(c?.content)?.map((item, index) => ({
    key: `${index + 1}`,
    role: item?.role,
    crm_integration: item.crm_integration || "N/A",
    status: item?.status || "N/A",
    voi:
      item?.merge_history?.vehicle_of_interest[0]?.make +
      item?.merge_history?.vehicle_of_interest[0]?.year +
      item?.merge_history?.vehicle_of_interest[0]?.model,
  }));

  const columns = [
    {
      dataIndex: "crm_integration",
      key: "crm_integration",
      onCell: () => ({
        style: {
          color: "#3B82F6",
          // backgroundColor: "#DCFCE7",
        },
      }),
    },
    {
      dataIndex: "voi",
      key: "voi",
      render: value => <span>{value || "No vehicle"}</span>,
      // onCell: () => ({
      //   style: { backgroundColor: "#DCFCE7" },
      // }),
    },
    {
      dataIndex: "role",
      key: "role",
      // onCell: () => ({
      //   style: { backgroundColor: "#DCFCE7" },
      // }),
    },
    {
      dataIndex: "status",
      key: "status",
      // onCell: () => ({
      //   style: { backgroundColor: "#DCFCE7" }, // Background for cells
      // }),
    },
  ];

  return (
    <Table
      dataSource={dataSource}
      columns={columns}
      pagination={false}
      className="hide-header divider-table"
    />
  );
}

function OttoMessage(props) {
  const {
    SetContentBy,
    c,
    userIdMap,
    selectedLead,
    toPhone,
    RenderRetry,
    messageCategory,
    isOpenOttoMessage,
    setisOpenOttoMessage,
    isReview,
    isLeadMerged,
    isOpportunityMerged,
    canEmailView,
  } = props;
  const isMobileView = useSelector(state => getMobileView(state));
  const messageContentType = (c?.contentType || "").toLowerCase();
  const showOttoMessage = isReview
    ? [
        MESSAGE_CONTENT_TYPES.REVIEW_REQUEST_SENT.toLowerCase(),
        MESSAGE_CONTENT_TYPES.CAMPAIGN_REVIEW_REQUEST_SENT_TO_LEAD.toLowerCase(),
        MESSAGE_CONTENT_TYPES.MANUAL_REVIEW_REQUEST_SENT_TO_LEAD.toLowerCase(),
      ].includes(messageContentType)
    : true;
  const RecieverName =
    c?.direction === "TO_LEAD"
      ? selectedLead?.fullName || ""
      : c?.direction === "FROM_OTTO" || c?.direction === "FROM_LEAD"
      ? c?.dateReceived
        ? `${c.user?.firstName || ""} ${c.user?.lastName || ""}`.trim()
        : c?.dateSent
        ? selectedLead?.fullName || ""
        : ""
      : "";

  return showOttoMessage ? (
    <div className="sm:w-[95%] w-full h-full flex flex-col items-center justify-center mx-auto">
      <div className="flex flex-col w-full items-center">
        <div className="flex flex-row w-full items-center">
          {/* <div
            className="h-0.5 sm:block hidden w-[25%]"
            style={{ backgroundColor: messageCategory.backgroundColor }}
          /> */}
          <LineDiv className={`flex items-center gap-1 mt-1 mb-2 w-full justify-center`}>
            <div className="flex py-0 px-[15px] w-[600px] flex-row items-center justify-center gap-1">
              <div
                className={`text-[#64748B] sm:text-nowrap line-clamp-1 block items-start justify-start ${
                  isMobileView && "w-1/4"
                } text-xs font-[400] leading-4`}
              >
                <Tooltip title={RecieverName}>
                  <span>{RecieverName}</span>
                </Tooltip>
              </div>
              <Tooltip
                title={
                  c?.direction === "TO_LEAD" || messageContentType.includes("to lead")
                    ? c?.messageType === "EMAIL"
                      ? "Sent email to lead"
                      : "Sent to lead"
                    : c?.messageType === "EMAIL"
                    ? "Sent email to employee"
                    : "Sent to employee"
                }
              >
                <div
                  style={{ backgroundColor: messageCategory.backgroundColor }}
                  className={`text-center p-[1px] rounded-full cursor-pointer ${
                    c?.direction === "TO_LEAD" || messageContentType.includes("to lead")
                      ? "cancel-otto"
                      : "normal-otto"
                  } `}
                  onClick={() => setisOpenOttoMessage(!isOpenOttoMessage)}
                >
                  <div className=" bg-white px-2 py-0.5 rounded-full flex flex-row items-center justify-center gap-2">
                    {messageCategory.icon}{" "}
                    <span className="text-xs font-[600] text-grey-700">
                      {messageCategory.title}
                    </span>
                    <CaretDownOutlined
                      className={`cursor-pointer ${
                        isOpenOttoMessage ? "rotate-180" : ""
                      } transition-all duration-500 `}
                    />
                  </div>
                </div>
              </Tooltip>
              <Tooltip
                title={convertUtcToLocal(
                  c?.dateSent || c?.dateReceived,
                  "ddd, MMM Do YYYY, h:mm A"
                )}
              >
                <div className="text-[#64748B] block sm:text-nowrap w-auto 4 text-xs font-[400]">
                  {convertUtcToLocal(c?.dateSent || c?.dateReceived, "h:mm A")}
                </div>
              </Tooltip>
            </div>
          </LineDiv>
        </div>
        {c?.messageType === "EMAIL" && (
          <div className="flex flex-row w-full items-center justify-center text-[#64748B] block sm:text-nowrap w-auto 4 text-xs font-[400] text-center mb-4">
            {renderEmailStatus(c?.email?.status)}
            {c?.email?.subject || ""}
          </div>
        )}
      </div>
      {isOpenOttoMessage && (
        <>
          <div
            style={{ wordBreak: "break-word" }}
            className={`sm:w-[70%] w-full whitespace-pre-wrap p-[1px] rounded-lg flex flex-col justify-start ${
              c?.direction === "TO_LEAD" || messageContentType.includes("to lead")
                ? "cancel-otto"
                : "normal-otto"
            }`}
          >
            <div className="flex flex-col justify-start items-start space-y-6 bg-white rounded-lg p-3.5 gap-1">
              {c?.messageType.toLowerCase() === "email" ? (
                <div className="text-grey-700 text-[14px] font-normal leading-6 w-full">
                  {canEmailView ? (
                    <EmailJSX
                      message={c}
                      user={c?.user}
                      isMobileView={isMobileView}
                      selectedLead={selectedLead}
                      canViewTranslation={false}
                      visibleTranslateIcon={false}
                      RenderTranslation={() => <></>}
                      isOttoEmail
                    />
                  ) : null}
                </div>
              ) : (
                <div className="text-grey-700 text-[14px] font-normal leading-6">
                  {(isLeadMerged && <MergedLeadUI c={c} />) ||
                    (isOpportunityMerged &&
                      (() => {
                        let parsedContent = [];
                        try {
                          parsedContent = c?.content ? JSON.parse(c.content) : [];
                        } catch (error) {
                          console.error("Invalid JSON:", error);
                          parsedContent = [];
                        }

                        return (
                          <div>
                            <div className="bg-[#DCFCE7] p-4 rounded-md mb-4">
                              {parsedContent.length} duplicate opportunities are merged with
                              Dealersocket {parsedContent[0]?.crm_integration || "N/A"}
                            </div>

                            <MergedOpportunityUI c={c} />
                          </div>
                        );
                      })()) ||
                    renderLinks(SetContentBy(c, userIdMap), "black") ||
                    ""}
                </div>
              )}
              {c?.messageType !== "EMAIL" && (
                <span className="text-xs font-[400] text-left">
                  {isOpenOttoMessage && `To: ${toPhone}`}
                </span>
              )}
            </div>
          </div>
        </>
      )}
      {(c?.type === "error" ||
        c?.messageStatus === "FAILED" ||
        c?.messageStatus === "UNDELIVERED") && (
        <div className="text-right w-full">
          <RenderRetry allowRetry={false} className="!justify-center" />
        </div>
      )}
      {isReview && <ReviewUI {...props} />}
    </div>
  ) : null;
}
